import(/* webpackMode: "eager" */ "/opt/app/meet/app/global-error.tsx");
